import { render, staticRenderFns } from "./ImageTextBlock.vue?vue&type=template&id=18440c42&"
import script from "./ImageTextBlock.vue?vue&type=script&lang=js&"
export * from "./ImageTextBlock.vue?vue&type=script&lang=js&"
import style0 from "./ImageTextBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDialog,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18440c42')) {
      api.createRecord('18440c42', component.options)
    } else {
      api.reload('18440c42', component.options)
    }
    module.hot.accept("./ImageTextBlock.vue?vue&type=template&id=18440c42&", function () {
      api.rerender('18440c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/proposal/proposal-renderer/ImageTextBlock.vue"
export default component.exports